import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-2xl">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-r from-green-500 to-emerald-500 mb-4">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">Gizlilik Politikası</h1>
          <p className="text-slate-400">HIMS Şarj İstasyonu Yönetim Platformu</p>
        </div>

        {/* Content Card */}
        <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl border border-slate-700 p-8">
          <div className="prose prose-invert max-w-none">
            <div className="text-center py-12">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-slate-700/50 flex items-center justify-center">
                <Shield className="w-8 h-8 text-slate-400" />
              </div>
              <h2 className="text-xl font-semibold text-white mb-2">Bu Sayfa Yakında Güncellenecektir</h2>
              <p className="text-slate-400 mb-6">
                Gizlilik politikamız hazırlanıyor. Kısa süre içinde burada yayınlanacaktır.
              </p>
              <p className="text-sm text-slate-500">
                Sorularınız için: <a href="mailto:info@himscharge.com" className="text-blue-400 hover:underline">info@himscharge.com</a>
              </p>
            </div>
          </div>

          {/* Back Link */}
          <div className="mt-8 pt-6 border-t border-slate-700">
            <Link 
              to="/register-technician" 
              className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Kayıt sayfasına dön
            </Link>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-slate-500 text-sm mt-6">
          © {new Date().getFullYear()} HIMS Charge. Tüm hakları saklıdır.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPage;
